define([
    "dojo/_base/array",
    "dojo/_base/declare",
    "csi/_base/underscore",
    "csi/heading/RefContainer"
], function(array,declare,_,RefContainer) {

    return declare(RefContainer, {
        getReferencedNodes: function(/*Context*/ctx, /*Heading*/h) {
            // summary: get nodes referenced by the heading attribute
            var cache = ctx.cache;
            var partMaterial = ctx.getNode();
            var visibleForColorsArray = partMaterial.OnlyForColors;
            return cache.getNodes(visibleForColorsArray);
        },

        getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
        //DE23670: Disable filter on column
            return null;
        }
    });
});
